export function createRefundClient(transport) {
    return {
        /**
         * List this tenant's refunds, most recently requested first
         *
         * Requires scope: refund:read
         */
        listRefunds(status, paymentIntentId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/refunds",
                query: { status: status, paymentIntentId: paymentIntentId, limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /v1/refunds
         *
         * Requires scope: refund:request
         */
        requestRefund(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/refunds",
                body,
                options,
            });
        },
        /**
         * GET /v1/refunds/{refundId}
         *
         * Requires scope: refund:read
         */
        getRefund(refundId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/refunds/${encodeURIComponent(refundId)}`,
                options,
            });
        },
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=refund.js.map